import { getPermissionByPrefix } from "./permissions";

export const getFirstAccessibleRoute = () => {
  const dashboardOverview = getPermissionByPrefix("dashboard_overview");
  const creditAchievement = getPermissionByPrefix("credit_achievement");
  const staffPermission = getPermissionByPrefix("manage_user");
  const vendorPermission = getPermissionByPrefix("manage_vendor");
  const documenthubPermission = getPermissionByPrefix("upload_document");
  const documentPermission = getPermissionByPrefix("manage_document");
  const rolePermission = getPermissionByPrefix("manage_roles");
  const locationPermission = getPermissionByPrefix("manage_location");
  const logPermission = getPermissionByPrefix("log_activity");

  if (dashboardOverview?.is_view || creditAchievement?.is_view) return "/dashboard";
  if (staffPermission?.is_view) return "/employee";
  if (vendorPermission?.is_view) return "/vendor";
  if (documenthubPermission?.is_view) return "/document-hub";
  if (documentPermission?.is_view) return "/document";
  if (locationPermission?.is_view) return "/location";
  if (rolePermission?.is_view) return "/role";
  if (logPermission?.is_view) return "/logs";

  return "/profile"; 
  // return "/not-found"; // Fallback route
};
